import { axiosInstance } from '~/src/config/config_axios'
import { convertInvoice } from '~/src/repositories/Invoice/helpers/ConvertInvoice'
import {
  IGetFileUpload,
  IGetInvoiceDetailResponse,
  IGetInvoiceParams,
  IGetInvoiceResponse,
  IPatchInvoiceBody,
} from '~/src/repositories/Invoice/models/Invoice'
import { makeQueryUrl } from '~/src/libs'
import { convertInvoiceDetail } from '~/src/repositories/Invoice/helpers/ConvertInvoiceDetail'

export class InvoiceRepository {
  async get(_params?: IGetInvoiceParams): Promise<IGetInvoiceResponse> {
    const data = await axiosInstance.get(makeQueryUrl(`/invoices`, _params))
    return convertInvoice(data.data)
  }

  async getDetail(_params?: IGetInvoiceParams): Promise<IGetInvoiceDetailResponse> {
    const data = await axiosInstance.get(makeQueryUrl(`/invoices`, _params))
    return convertInvoiceDetail(data.data)
  }

  async path(invoiceId: number, _body: IPatchInvoiceBody): Promise<void> {
    return await axiosInstance.patch(`/invoices/${invoiceId}`, _body)
  }
  async getFile(): Promise<IGetFileUpload['data']> {
    const data = await axiosInstance.get(`/fileupload-url`)
    return data.data
  }

  async putFileUpload(url: string, file: File): Promise<void> {
    if (!file) return
    return axiosInstance.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    })
  }
}
